import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { ChildFragmentFragment } from "@outschool/gql-frontend-generated";
import { useCallback } from "react";

import useLearnerSpecificSearchV4Experiment from "./useLearnerSpecificSearchV4Experiment";

export function useActiveLearnerSearchFilters(): typeof getSearchFilters {
  const { variant } = useLearnerSpecificSearchV4Experiment();
  const getSearchFilters = useCallback(
    (activeLearner: ChildFragmentFragment | null): SearchFiltersType => {
      if (!activeLearner || variant !== "treatment") {
        return {
          age: null,
          theme: null,
          format: null,
          capacityMin: null,
          capacityMax: null,
          startAfterTime: null,
          endByTime: null,
          dow: null,
        };
      }

      return activeLearner.age ? { age: activeLearner.age.toString() } : {};
    },
    [variant],
  );

  return getSearchFilters;
}
